<template>
    <div
        class="l-ss-c-voice-search-container">
        <div
            class="l-ss-c-voice-search-microphone"
            :class="{ 'l-ss-c-voice-search-microphone-active': isActiveVoice }">
            <div class="l-ss-c-voice-search-microphone-inner">
                <i v-html="microphoneIcon"></i>
            </div>
        </div>
        <p class="l-ss-c-voice-search-text">{{ searchText }}</p>
    </div>
</template>

<script>
    import microphoneIcon from '@/core/assets/images/icons/microphone.svg';

    export default {
        name: 'voice-search-container',
        props: {
            store: {
                type: Object,
                required: true,
            },
        },
        computed: {
            microphoneIcon() {
                return microphoneIcon;
            },

            isActiveVoice() {
                return !!this.currentVoiceSearchQuery.length;
            },

            currentVoiceSearchQuery() {
                return this.store.state.ui.currentVoiceSearchQuery;
            },

            searchText() {
                return this.currentVoiceSearchQuery ? this.currentVoiceSearchQuery : this.$t('voiceSearch.placeholder');
            },
        },
    };
</script>
